export const DICTIONARIES_SAVE_FOLDER = 'DICTIONARIES_SAVE_FOLDER';
export const DICTIONARIES_LIST_FOLDER = 'DICTIONARIES_LIST_FOLDER';
export const DICTIONARIES_LIST_DICTIONARY = 'DICTIONARIES_LIST_DICTIONARY';
export const DICTIONARIES_GET_DICTIONARY = 'DICTIONARIES_GET_DICTIONARY';
export const DICTIONARIES_CLEAR_DICTIONARY = 'DICTIONARIES_CLEAR_DICTIONARY';
export const DICTIONARIES_CLEAR_ITEMS = 'DICTIONARIES_CLEAR_ITEMS';
export const DICTIONARIES_LIST_ITEMS = 'DICTIONARIES_LIST_ITEMS';
export const START_DICTIONARY_SAVE = 'START_DICTIONARY_SAVE';
export const SUCCESS_DICTIONARY_SAVE = 'SUCCESS_DICTIONARY_SAVE';
export const ERROR_DICTIONARY_SAVE = 'ERROR_DICTIONARY_SAVE';